import { TabsLayout } from "#layouts";

export const Patient = () => (
	<TabsLayout entity="patient" basePath="/patient" paramName="patientID" />
);
